import loadable from '@loadable/component';

export const ViewUserProfilePageLoadable = loadable(
  () => import('./ViewUserProfilePage'),
  { resolveComponent: (module) => module.ViewUserProfilePage },
);
